// Route href vocabulary of the Property & Loan edit modal, kept import-light so
// non-page consumers (e.g. the loanNavigation service) can read the route contract
// without pulling the modal's full component tree (mirrors EditEntityModal.hrefs).
export const ENTITY_TYPE_HREF_MAP = {
  PROPERTY_INFO: 'property-info',
  LOAN_AND_LOCK: 'loan-and-lock',
  CONTACTS: 'contacts',
  CHATTEL: 'chattel-info',
};

// The loan's contacts are edited from the Contacts tab (LEN2-798); Property & Loan opens the rest.
export const PROPERTY_AND_LOAN_ENTITY_TYPES = [
  ENTITY_TYPE_HREF_MAP.PROPERTY_INFO,
  ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK,
  ENTITY_TYPE_HREF_MAP.CHATTEL,
];

export const CONTACTS_TAB_ENTITY_TYPES = [ENTITY_TYPE_HREF_MAP.CONTACTS];

export const PROPERTY_SECTION_HREF_MAP = {
  PROPERTY: 'property',
  PROPERTY_EXPENSES: 'property-expenses',
  AGENT_AND_SELLER: 'agent-and-seller',
  APPRAISAL: 'appraisal',
  PROJECT: 'project',
  TRANSACTION_DETAILS: 'transaction-details',
  CUSTOM_FIELDS: 'custom-fields',
};

export const LOAN_AND_LOCK_SECTION_HREF_MAP = {
  LOAN_INFO: 'loan-info',
  LOCK_INFO: 'lock-info',
  SELL_SIDE_LOCK: 'sell-side-lock',
  ADDITIONAL_FINANCING: 'additional-financing',
  LOAN_PL: 'loan-pl',
  PROGRAMS_PRICING: 'programs-pricing',
  CREDITS: 'credits',
  LOAN_TAGS: 'loan-tags',
  LOAN_ROLES: 'loan-roles',
  OB_CUSTOM_FIELDS: 'ob-custom-fields',
  MORTGAGE_INSURANCE: 'mortgage-insurance',
  CUSTOM_FIELDS: 'custom-fields',
};
